import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { categoriesAdapter } from "@/data";
import { toast } from "@/hooks/use-toast";
import { categoriaSchema } from "@/schemas/tabelasAuxiliaresSchemas";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  mode: "create" | "edit";
  item: any | null;
  onSuccess: () => void;
}

export function CategoriaProdutoFormDialog({ open, onOpenChange, mode, item, onSuccess }: Props) {
  const { register, handleSubmit, reset, formState: { errors } } = useForm({
    resolver: zodResolver(categoriaSchema),
  });

  useEffect(() => {
    if (open) {
      if (mode === "edit" && item) {
        reset({ nome: item.nome });
      } else {
        reset({ nome: "" });
      }
    }
  }, [open, mode, item, reset]);

  const onSubmit = async (data: any) => {
    try {
      if (mode === "create") {
        await categoriesAdapter.create(data);
        toast({ title: "Sucesso", description: "Categoria criada com sucesso!" });
      } else if (item) {
        await categoriesAdapter.update(item.id_categoria, data);
        toast({ title: "Sucesso", description: "Categoria atualizada com sucesso!" });
      }
      onSuccess();
    } catch (error: any) {
      console.error("Erro ao salvar categoria:", error);
      toast({ 
        title: "Erro", 
        description: error.message || "Não foi possível salvar.",
        variant: "destructive" 
      });
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{mode === "create" ? "Nova Categoria" : "Editar Categoria"}</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div>
            <Label>Nome *</Label>
            <Input {...register("nome")} required />
            {errors.nome && <p className="text-sm text-destructive mt-1">{errors.nome.message as string}</p>}
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
            <Button type="submit">Salvar</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
